<template>
  <v-card
    width="400"
    elevation="24"
  >
    <v-row
      align="center"
      justify="center"
      style="height: 100%"
    >
      <v-col>
        <v-row
          align="center"
          justify="center"
          class="ma-5"
          id="login-header"
        >
          <h1> Sign in </h1>
        </v-row>
        <v-row
          align="center"
          justify="center"
        >
          <v-col>
            <v-form
              ref="form"
              v-model="valid"
            >
              <!-- <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="email"
                  color="orange"
                  class="login-form-element"
                  label="Email Address"
                  rounded
                  solo
                  prepend-inner-icon="mdi-email"
                  @keydown.enter="validateLogin"
                  :rules="[authorizedMessage]"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-text-field
                  v-model="password"
                  color="orange"
                  class="login-form-element"
                  label="Password"
                  rounded
                  solo
                  prepend-inner-icon="mdi-key"
                  type="password"
                  @keydown.enter="validateLogin"
                  :rules="[authorizedMessage]"
                />
              </v-row>
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-btn
                  height="50px"
                  class="login-form-element"
                  color="rgb(255, 149, 24)"
                  rounded
                  @click="validateLogin"
                >
                  Login
                </v-btn>
              </v-row> -->
              <v-row
                align="center"
                justify="center"
                style="height: 100%"
              >
                <v-btn
                  height="50px"
                  class="login-form-element my-8"
                  color="rgb(255, 149, 24)"
                  rounded
                  :href="loginRedirectLink"
                >
                  Log in with Basadur
                </v-btn>
              </v-row>
            </v-form>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'LoginCard',

  data: () => ({
    email: '',
    password: '',
    valid: false,

    // whether the client is authorized to enter
    authorized: false,

    // whether the form helper messages should be displayed
    authorizedMessage: true
  }),

  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo
    }),
    loginRedirectLink () {
      if (process.env.NODE_ENV === 'development') {
        return '/#/admin-dashboard'
      } else {
        const queryParams = new URLSearchParams(this.$route.query).toString()
        return `/id/init?${queryParams}`
      }
    }
  },

  async mounted () {
    // this.authLogout()
    const userIsLoggedIn = await this.requestUserIsLoggedIn()
    if (userIsLoggedIn) {
      console.log(this.$route.query.challenge)
      if (this.$route.query.challenge) {
        this.$router.push(`/whiteboard/${this.$route.query.challenge}`)
      } else {
        this.$router.push('/admin-dashboard')
      }
    }
  },

  methods: {
    ...mapActions([
      'authRequest',
      'authLogout',
      'setupState',
      'requestActivateChallenge',
      'requestUserIsLoggedIn'
    ]),

    async validateLogin () {
      var response = await this.authRequest({
        email: this.email,
        password: this.password
      })

      this.authorized = response.success

      // activate the form helper messages
      this.activateAuthorizedRule()

      // only login if the request succeeded
      if (response.success) {
        await this.setupState()
        if (this.$route.query.challenge) {
          await this.requestActivateChallenge(this.$route.query.challenge)
          this.$router.push('/whiteboard')
        } else {
          this.$router.push((this.userInfo.type === 'admin') ? '/admin-dashboard' : '/user-dashboard')
        }
      }
    },

    activateAuthorizedRule () {
      // vuetify validates upon any keypress, so this supresses
      // the 'Username or Password is incorrect.' until the user
      // presses login
      this.authorizedMessage = () => (this.authorized === true) || 'Email Address or Password is incorrect.'
    },

    forgotPassword () {
      this.$router.push('/forgotPassword')
    }
  }
}
</script>

<style lang="sass" scoped>
  #login-header
    top: -10px

  .login-form-element
    width: 75%
    max-width: 75%
</style>
